import React from 'react';
export interface HeadingProps {
  children: React.ReactNode;
  className?: string;
  hLevel: HeadingLevel;
}

export enum HeadingLevel {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

export const Heading = ({ className, children, hLevel = HeadingLevel.h1 }: HeadingProps) => {
  if (!children) return null;
  return React.createElement(hLevel, { className }, children);
};
